// extracted by mini-css-extract-plugin
export default {"base":"DialogConfirmationTicket_base__aDcuw","content":"DialogConfirmationTicket_content__+X9lt","button":"DialogConfirmationTicket_button__04ese"};